import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import DialogContentText from '@mui/material/DialogContentText';
import MaterialTextField from '@mui/material/TextField';
import ConfirmButton from '../confirm-button';
import { approveEventMemberMutation } from '../../apollo/events';
import type { EventMember } from '../../types/EventMember';

type Props = {
  member?: EventMember;
};

const EventApproveMemberButton = ({ member }: Props) => {
  const [approveEventMember] = useMutation(approveEventMemberMutation);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  return (
    <ConfirmButton
      label="Approve"
      message="Approve Request"
      variant="contained"
      size="small"
      color="primary"
      onClick={() => {
        setSubmitting(true);
        approveEventMember({
          variables: {
            id: member.id,
            message
          }
        }).then(() => {
          setSubmitting(false);
        }).catch(() => {
          alert('An error occurred while submitting. Please try again.');
          setSubmitting(false);
        });
      }}
      disabled={submitting}
    >
      <DialogContentText>
        Approve {member.user.displayName}&lsquo;s request to join
      </DialogContentText>
      <MaterialTextField
        autoFocus
        id="message"
        label="Message to requester"
        fullWidth
        multiline
        rows={3}
        maxRows={20}
        variant="outlined"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
      />
    </ConfirmButton>
  );
};

export default EventApproveMemberButton;
